import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const BannerArrow = () => {
    return (
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            viewBox="0 0 1000 1000"
            enableBackground="new 0 0 1000 1000"
            fill="#006ae3"
        >
            <g>
                <path d="M767.9,499.9L291.6,10l-59.4,61.3l416.6,428.7L232.1,928.7l59.5,61.3L767.9,499.9z"></path>
            </g>
        </svg>
    );
};

export default BannerArrow;
